<mat-horizontal-stepper>
  <mat-step>
    <ng-template matStepLabel>Email 1</ng-template>
    <ng-template matStepContent>
      <p><b>Subject Line: {{ getContent('email_template1').subject }}</b></p>
      <p>{{ getContent('email_template1').greeting }}</p>
      <app-html-viewer [html]="getContent('email_template1').content_attention"></app-html-viewer>
      <app-html-viewer [html]="getContent('email_template1').first_benefit"></app-html-viewer>
      <app-html-viewer [html]="getContent('email_template1').second_benefit"></app-html-viewer>
      <app-html-viewer [html]="getContent('email_template1').content_closing"></app-html-viewer>
      <hr>
      <app-html-viewer [html]="getContent('email_template1').content_sign"></app-html-viewer>
      <app-html-viewer [html]="getContent('email_template1').content_details"></app-html-viewer>
    </ng-template>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Email 2</ng-template>
    <ng-template matStepContent>
      <p><b>Subject Line: {{ getContent("email_template2").subject }}</b></p>
      <p>{{ getContent("email_template2").greeting }}</p>
      <app-html-viewer [html]='getContent("email_template2").content_opening'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template2").second_benefit'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template2").content_attention'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template2").first_benefit'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template2").content_closing'></app-html-viewer>
      <hr>
      <app-html-viewer [html]='getContent("email_template2").content_sign'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template2").content_details'></app-html-viewer>
    </ng-template>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Email 3</ng-template>
    <ng-template matStepContent>
      <p><b>Subject Line: {{ getContent("email_template3").subject }}</b></p>
      <p>{{ getContent("email_template3").greeting }}</p>
      <app-html-viewer [html]='getContent("email_template3").content_opening'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template3").first_benefit'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template3").second_benefit'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template3").content_closing'></app-html-viewer>
      <hr>
      <app-html-viewer [html]='getContent("email_template3").content_sign'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template3").content_details'></app-html-viewer>
    </ng-template>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Email 4</ng-template>
    <ng-template matStepContent>
      <p><b>Subject Line: {{ getContent("email_template4").subject }}</b></p>
      <p>{{ getContent("email_template4").greeting }}</p>
      <app-html-viewer [html]='getContent("email_template4").content_opening'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template4").first_benefit'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template4").content_attention'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template4").content_closing'></app-html-viewer>
      <hr>
      <app-html-viewer [html]='getContent("email_template4").content_sign'></app-html-viewer>
      <app-html-viewer [html]='getContent("email_template4").content_details'></app-html-viewer>
    </ng-template>
  </mat-step>
</mat-horizontal-stepper>